export default "__VITE_ASSET__BTtW4jfX__"